import { useAuthToken } from '~/queries/auth/token'

/**
 * Bearer-token resolver for `useCollaborationAgent`'s `query` option. Called
 * before every (re)connect, so a token that expired while the socket was down
 * is refreshed instead of failing the WebSocket upgrade.
 */
export const useCollabAuthQuery = () => {
  const { refresh } = useAuthToken()
  /* Called only on (re)connect, not per-message, so the round-trip is
     bounded. Unconditionally refreshing avoids handing back a cached token
     whose JWT `exp` has passed while Pinia Colada's status stayed 'success' —
     which would 401 the upgrade and loop the reconnect. */
  return async (): Promise<Record<string, string>> => {
    const { data } = await refresh()
    return { token: data ?? '' }
  }
}
